export default "__VITE_ASSET__DV$D$YVo__"